export default "__VITE_ASSET__HjksZ9ls__"